const isPlaceholder = (_) => _ === '_';
const isDigit = (_) => /\d/.test(_);
const isWildcard = (_) => isPlaceholder(_) || isDigit(_);
const phonePattern = [...'+7 (___) ___-__-__'];
const firstPlaceholderIndex = phonePattern.findIndex(isPlaceholder);
const phoneWildcardIndicies = phonePattern.map((_, i) => isWildcard(_) ? phonePattern.slice(0, i).filter(isWildcard).length : -1);
export function normalizePhone(phone) {
    const phoneNumbers = phone.replace(/\D/g, '');
    const applyPlaceholder = (_, i) => isDigit(_) ? _ : phoneNumbers.charAt(phoneWildcardIndicies[i]) || _;
    const result = phonePattern.map(applyPlaceholder);
    const resultLength = phoneWildcardIndicies.indexOf(phoneNumbers.length - 1) + 1;
    return (resultLength ? result.slice(0, Math.max(firstPlaceholderIndex, resultLength)) : result).join('');
}
//# sourceMappingURL=normalizePhone.js.map